<template>
  <div v-if="surveyName">
    <div class="gf_survey gf_survey-container">
      <div class="gf_survey-head">
        <div class="gf_survey-head--title">{{ titleSurvey }}</div>
        <div class="gf_survey-head--close" @click="closeFormSurvey">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.64645 2.64645C2.84171 2.45118 3.15829 2.45118 3.35355 2.64645L13.3536 12.6464C13.5488 12.8417 13.5488 13.1583 13.3536 13.3536C13.1583 13.5488 12.8417 13.5488 12.6464 13.3536L2.64645 3.35355C2.45118 3.15829 2.45118 2.84171 2.64645 2.64645Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3536 2.64645C13.5488 2.84171 13.5488 3.15829 13.3536 3.35355L3.35355 13.3536C3.15829 13.5488 2.84171 13.5488 2.64645 13.3536C2.45118 13.1583 2.45118 12.8417 2.64645 12.6464L12.6464 2.64645C12.8417 2.45118 13.1583 2.45118 13.3536 2.64645Z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <PerfectScrollbar class="gf_survey-body" :class="{ 'gf_survey-two': surveyName == sheet.SURVEY_2 }" :options="scrollOptions">
        <div class="gf_survey-body__list">
          <template v-for="(value, key) in survey">
            <div class="gf_survey-wrap-item" :key="key" v-if="key != 'answerOthersText'">
              <div class="gf_survey-item" @click="onChecked(key)">
                <label v-if="surveyName == sheet.SURVEY_1" class="gf_checkbox-wrap">
                  <svg v-if="checkChecked(key)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="15" height="15" rx="3" fill="#547AFF" />
                    <path d="M3.71422 8.82394L6.68908 11.75L12.2857 4.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.125" y="1.125" width="13.75" height="13.75" rx="2.375" stroke="#AAAAAA" stroke-width="1.25" />
                  </svg>
                  <input class="checkbox" type="checkbox" v-if="surveyName == sheet.SURVEY_1" v-model="survey[key].value" @click="onChecked(key)" />
                </label>
                <label v-else class="gf_checkbox-wrap">
                  <svg v-if="!checkChecked(key)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="7.375" stroke="#AAAAAA" stroke-width="1.25" />
                  </svg>
                  <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="4.25" fill="#547AFF" />
                    <rect x="0.625" y="0.625" width="14.75" height="14.75" rx="7.375" stroke="#547AFF" stroke-width="1.25" />
                  </svg>
                  <input class="checkbox" type="radio" name="survey" :checked="checkChecked(key)" :value="survey[key].value" @click="onChecked(key)" />
                </label>
                <div class="gf_survey-item--txt">{{ $t(`survey2.${key}`) }}</div>
              </div>
              <div class="gf_survey-item-area" v-show="survey[key].value && survey[key].useText">
                <textarea :ref="key" class="gf_survey__text-area mb-0" :placeholder="$t(`survey2.placeholder.${key}`)" type="text" v-model="survey[key].text"></textarea>
              </div>
            </div>
          </template>
        </div>
      </PerfectScrollbar>
      <div class="gf_survey-footer">
        <div class="gf_survey-footer_action">
          <button :class="`gf_survey-button--${unDisableButton ? 'dark' : 'disabled'}`" @click.prevent="onSubmitSurvey()">
            {{ $t("survey.submit") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import googleSheet from "@/mixins/googleSheet";
import { cloneDeep } from "@/shared";
import { PLAN_NO } from "@/contants/plan";

const GOOGLE_SHEET_ID = "16kXUkMq9GYjcsGvYWuAAZVO3Mq3YYAkWCAl0-qnK8bs";
const SURVEY_START_TIME = "2023-06-21T00:00:00.000Z";
const MIN_TIME_SINCE_LAST_ATTEMPT_MS = 2 * 24 * 60 * 60 * 1000;
const MINIMUM_INSTALLATION_TIME_MS = 3 * 24 * 60 * 60 * 1000;

export default {
  name: "SurveyReasonNotUpgrading",
  mixins: [googleSheet(GOOGLE_SHEET_ID)],
  data() {
    return {
      sheet: {
        SURVEY_1: "Survey 1",
        SURVEY_2: "Survey 2"
      },
      survey: {},
      survey1: {
        answerPriceBudget: {
          value: false
        },
        answerHardToUse: {
          value: false
        },
        answerMissingFeatures: {
          value: false,
          useText: true,
          text: ""
        },
        answerTechnicalIssues: {
          value: false
        },
        answerOthers: {
          value: false,
          useText: true,
          text: ""
        }
      },
      survey2: {
        answerGoogleSearch: {
          value: false
        },
        answerShopifyAppStore: {
          value: false
        },
        answerLinkedin: {
          value: false
        },
        answerFacebook: {
          value: false
        },
        answerTwitter: {
          value: false
        },
        answerYoutube: {
          value: false,
          useText: true,
          text: ""
        },
        answerCommunity: {
          value: false,
          useText: true,
          text: ""
        }
      },
      answerOthersText: "",
      surveyName: "",
      unDisableButton: false
    };
  },
  computed: {
    ...mapState({
      shopInfo: state => state.account.shopInfo
    }),

    titleSurvey() {
      switch (this.surveyName) {
        case this.sheet.SURVEY_1:
          return this.$t("survey2.1.title");
        case this.sheet.SURVEY_2:
          return this.$t("survey2.2.title");
        default:
          return "";
      }
    },

    formQuestion() {
      switch (this.surveyName) {
        case this.sheet.SURVEY_1:
          return this.survey1;
        case this.sheet.SURVEY_2:
          return this.survey2;
        default:
          return "";
      }
    },

    isTrial() {
      return this.shopInfo.plan === PLAN_NO.TRIAL2022 || this.shopInfo?.plan === PLAN_NO.TRIAL;
    },

    scrollOptions() {
      return {
        wheelSpeed: 0.25,
        swipeEasing: true,
        wheelPropagation: false,
        suppressScrollX: true
      };
    }
  },
  created() {
    this.initSurvey();
  },
  methods: {
    initSurvey() {
      if (!this.isTrial) return;
      const installDate = this.shopInfo.createdAt;
      const currentDate = new Date().toISOString();

      const isShowSurvey1 = this.hasReachedMinimumUsageDuration(installDate, currentDate);
      const isShowSurvey2 = this.isInstallationAfterSurveyStart(installDate);
      const surveysShown = JSON.parse(localStorage.getItem("surveysShown2") || "[]");
      const surveyName = isShowSurvey1 ? this.sheet.SURVEY_1 : isShowSurvey2 ? this.sheet.SURVEY_2 : "";

      this.handleSurvey(surveysShown, surveyName, currentDate);
      this.survey = this.formQuestion;
      return;
    },
    onSubmitSurvey() {
      if (!this.unDisableButton) return;

      let survey = this.replaceValue(this.survey);
      const surveyData = Object.values(survey);
      this.addNewRowToSheetByTitle(this.surveyName, surveyData);
      this.closeFormSurvey();
      this.gSnackbarCommit({
        message: this.$t("survey.notifySuccess"),
        type: "success"
      });
    },
    replaceValue(survey) {
      const timeDomain = {
        time: this.getDate(),
        domain: this.shopInfo.shopifyDomain
      };
      const objSurvey = cloneDeep(survey);
      const dataSurvey = {};
      Object.keys(objSurvey).forEach(key => {
        if (objSurvey[key].useText && objSurvey[key].text && objSurvey[key].value) {
          dataSurvey[key] = objSurvey[key].text;
        } else {
          dataSurvey[key] = objSurvey[key].value;
        }
      });
      return Object.assign(timeDomain, dataSurvey);
    },
    handleSurvey(surveysShown, surveyName, currentDate) {
      const surveyRecord = surveysShown.find(item => item.domain === this.shopInfo.shopifyDomain && item.surveyName === surveyName);

      if (!surveyRecord) {
        surveysShown.push({
          domain: this.shopInfo.shopifyDomain,
          surveyName: surveyName,
          isShowed: false,
          time: currentDate
        });
        localStorage.setItem("surveysShown2", JSON.stringify(surveysShown));
        this.surveyName = surveyName;
      } else if (!surveyRecord.isShowed) {
        const isTimeAfterLastAttempt = this.isTimeAfterLastAttempt(surveyRecord.time, currentDate);
        if (isTimeAfterLastAttempt) {
          this.surveyName = surveyName;
          this.updateSurveyInLocalStorage(surveyName, true);
        }
      }

      return;
    },
    updateSurveyInLocalStorage(surveyName, isShowed) {
      let surveysShown = JSON.parse(localStorage.getItem("surveysShown2") || "[]");
      surveysShown = surveysShown.map(item => {
        if (item.domain === this.shopInfo.shopifyDomain && item.surveyName === surveyName) {
          item.isShowed = isShowed;
        }
        return item;
      });
      localStorage.setItem("surveysShown2", JSON.stringify(surveysShown));
    },
    isTimeAfterLastAttempt(lastAttemptDate, currentDate) {
      const lastAttemptDateTime = new Date(lastAttemptDate).getTime();
      const currentDateTime = new Date(currentDate).getTime();

      return currentDateTime - lastAttemptDateTime >= MIN_TIME_SINCE_LAST_ATTEMPT_MS;
    },
    hasReachedMinimumUsageDuration(installDate, currentDate) {
      const installDateTime = new Date(installDate).getTime();
      const currentDateTime = new Date(currentDate).getTime();

      return currentDateTime >= installDateTime + MINIMUM_INSTALLATION_TIME_MS;
    },
    isInstallationAfterSurveyStart(installDate) {
      const surveyStartTime = new Date(SURVEY_START_TIME).getTime();
      const installDateTime = new Date(installDate).getTime();

      return installDateTime > surveyStartTime;
    },
    getDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, "0");
      const day = now
        .getDate()
        .toString()
        .padStart(2, "0");
      const hours = now
        .getHours()
        .toString()
        .padStart(2, "0");
      const minutes = now
        .getMinutes()
        .toString()
        .padStart(2, "0");
      const seconds = now
        .getSeconds()
        .toString()
        .padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    closeFormSurvey() {
      this.updateSurveyInLocalStorage(this.surveyName, true);
      this.surveyName = "";
    },
    checkChecked(key) {
      return !!this.survey[key].value;
    },
    onChecked(key) {
      if (this.surveyName === this.sheet.SURVEY_1) {
        this.toggleValue(key);
      }

      if (this.surveyName === this.sheet.SURVEY_2 && !this.survey[key].value) {
        this.uncheckOtherOptions(key);
        this.toggleValue(key);
      }

      this.unDisableButton = this.validate();
      this.setFocus(key);
    },

    setFocus(key) {
      this.$nextTick(() => {
        if (this.survey[key].value && this.survey[key].useText && this.$refs[key] && this.$refs[key][0]) {
          this.$refs[key][0].focus();
        }
      });
      return;
    },

    toggleValue(key) {
      this.survey[key].value = !this.survey[key].value;
    },

    uncheckOtherOptions(key) {
      for (const otherKey in this.survey) {
        if (otherKey !== key) {
          this.survey[otherKey].value = false;
        }
      }
    },
    validate() {
      return Object.values(this.survey).some(item => item.value === true);
    }
  }
};
</script>

<style lang="scss" scoped>
.gf_survey {
  position: fixed;
  z-index: 99;
  bottom: 24px;
  right: 88px;
  width: 340px;
  min-height: 234px;
  background: map-get($hybrid-shade-dark, "500");
  border-radius: 3px;
  color: #ffffff;
  display: flex;
  flex-direction: column;

  &-head {
    display: flex;
    justify-content: space-between;
    padding: 12px 8px 8px 16px;
    align-items: start;

    &--title {
      font-family: "Inter";
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: #ffffff;
      margin-right: 8px;
    }

    &--close {
      padding: 8px;
      cursor: pointer;
      display: flex;
      border-radius: 3px;
      max-height: 32px;

      svg {
        width: 16px;
        height: 16px;
      }

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
    }
  }

  &-body {
    flex: 1;
    height: 100%;
    padding: 8px 0;
    overflow: overlay;
    max-height: 220px;
    padding: 0 16px;

    &.gf_survey-two {
      max-height: 308px;
    }

    .gf_survey-wrap-item {
      cursor: pointer;
      border: 1px solid #323232;
      border-radius: 3px;
      margin-bottom: 8px;
    }

    .gf_survey-item {
      display: flex;
      padding: 7px;
      align-items: center;
      color: map-get($text-dark-mode, "high-contrast");
      border-radius: 3px 3px 0 0;

      &:hover {
        background-color: #444545;
      }

      .gf_checkbox-item {
        margin-right: 4px !important;
        padding: 2px;
      }

      .gf_checkbox-wrap {
        margin-right: 4px !important;
        padding: 2px;
      }

      &--txt {
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 150%;
        color: map-get($text-dark-mode, "high-contrast");
      }

      &-area {
        padding-left: 31px;
        margin-top: 3px;
        margin-bottom: 8px;
      }
    }
  }

  &-footer {
    padding: 0 16px 16px 16px;

    &_action {
      display: flex;
      justify-content: flex-end;
      overflow: hidden;

      button {
        transition: all 0.25s ease;
        padding: 9.5px 16px;
        border-radius: 3px;
        border: none;
        cursor: pointer;
        white-space: nowrap;
        width: 100%;
        font-family: "Inter";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 150%;
        text-align: center;
      }

      .gf_survey-button {
        &--dark {
          background: map-get($hybrid-shade-dark, "300");
          color: map-get($text-dark-mode, "high-contrast");

          &:hover {
            background: #5b5b5b;
          }
        }

        &--disabled {
          background: map-get($hybrid-shade-dark, "300");
          color: map-get($text-dark-mode, "disabled");
          cursor: not-allowed;
        }
      }
    }
  }

  &__text-area {
    padding: 7px;
    border: 1px solid map-get($hybrid-shade-dark, "400");
    border-radius: 3px;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    display: flex;
    color: map-get($text-dark-mode, "high-contrast");
    width: calc(100% - 7px);
    max-width: calc(100% - 7px);
    overflow: overlay;
    overflow-x: hidden;
    background: map-get($hybrid-shade-dark, "400");
    resize: none;

    &:focus {
      border: 1px solid map-get($primary-blue, "300");
    }

    &::placeholder {
      font-family: "Inter";
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 150%;
      display: flex;
      align-items: center;
      color: map-get($text-dark-mode, "disabled");
    }
  }
}

.gf_checkbox {
  width: 20px;
  height: 20px;
  @include flex-center;
}

.gf_checkbox-wrap {
  display: flex;
  position: relative;
  margin-bottom: 6px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  font-size: 16px;
  margin: 0;
  margin-right: 4px;

  .checkbox {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    display: none;
  }
}
</style>
